import init from '../../helpers/init';
import {showAlert} from "../main";

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('change', '.js-select-exhibition', (e) => {
    const value = $(e.target).val();
    window.location.href = value.toString();
  });

  $(document).on('change', '.js-load-subquestions', (e) => {
    const id = $(e.currentTarget).data('id');
    console.log(id);
  });

  $(document).on('click', '.ticketPay', (e) => {
    e.preventDefault();
    const url = $(e.currentTarget).data('href');
    console.log(url);

    $.ajax({
      url,
      method: 'GET',
      dataType: 'html'
    }).done((data) => {
      $('#ticketWrapper').html(data);
      $(document).find('footer').after($('#ticketWrapper'));
      $('#ticketPayment').modal('show');
    }).fail(() => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
    });
  });

  $(document).on('click', '#sale-paysystem-yandex', (e) => {
    const agree = <HTMLInputElement>document.getElementById('payment_agree');
    if (agree.checked) {
      if($('#payform').find('.js-is-payment-link a').length){
        let paymentLink = $('#payform').find('.js-is-payment-link a').first().attr('href');
        window.location.href = paymentLink;
      }else {
        $("#payform").find("form input[type='submit']").click();
      }
    } else {
      $(e.currentTarget).after('<div class="alert alert-danger" style="display: block;">\n' +
        '\t\t\t\t<span style="color: #ff0000;">' + (BX.message('LANGUAGE_ID') === 'en' ? 'Please confirm your acceptance of the payment and return policy.' : 'Подтвердите согласие с политикой оплаты и возврата.') + '</span>\t\t\t</div>');
    }
  });

  $(document).on('click', '.js-order-bill-button', (e) => {
    e.preventDefault();
    console.log('bill');

    const selector = 'select.js-search-select';
    const orderIdInput = 'input.js-bill-order-id';
    const modalContentId = 'ticketPayment-modal-content';

    if (!$('#bill_agree').is(':checked')) {
      alert(BX.message('LANGUAGE_ID') === 'en' ? 'Please confirm agreement with the terms of payment by bank transfer.' : 'Подтвердите согласие с условиями оплаты по безналичному расчёту');
    } else if ($(selector).length && $(selector).val() && $(orderIdInput) && $(orderIdInput).val()) {
      const cData = $(selector).val();
      const orderId = $(orderIdInput).val();
      $('.js-search-block-result').html('');

      let waitBlock = BX.showWait(modalContentId);
      $('.modal-backdrop').css('--bs-backdrop-zindex', '999');
      $('.modal').css('--bs-modal-zindex', '1000');
      $('#' + modalContentId).find('.modal-footer').hide();

      const request = BX.ajax.runComponentAction('alx:order.bill', 'createBill', {
        mode: 'ajax',
        data: {
          'orderId': orderId,
          'cData': JSON.parse(<string>cData)
        }
      });

      request.then(function (response: any) {
        $('.js-bill-popup-screen').addClass('hide');
        $('.js-bill-popup-first-screen').removeClass('hide');
        if (response && response.status === 'success') {
          if (response.data.crm && 'Y' === response.data.crm) {
            $('.js-search-block-result').html(BX.message('LANGUAGE_ID') === 'en' ? 'The bill is created' : 'Счёт сформирован');
          } else {
            $('.js-search-block-result').html(BX.message('LANGUAGE_ID') === 'en' ? 'The bill sent by mail' : 'Счёт отправлен на почту');
          }
          const locationHref = location.href;

          // tslint:disable-next-line:ter-prefer-arrow-callback
          setTimeout(function () {
            location.href = locationHref.replace('&EDIT=Y', '');
          }, 2000);

        } else {
          BX.closeWait(modalContentId, waitBlock);
          $('#' + modalContentId).find('.modal-footer').show();
          console.log(response)
          alert('Request error!');
        }
      }, (response: any) => {
        BX.closeWait(modalContentId, waitBlock);
        $('#' + modalContentId).find('.modal-footer').show();
        console.log(response)
        alert('Request error!');
      });
    }else{
      alert(BX.message('LANGUAGE_ID') === 'en' ? 'Company not selected or order not defined' : 'Компания не выбрана или заказ не определен');
    }
  });

  $(document).on('keyup', '.js-companies-search-input', function(){
    const query = $(this).val();
    const selector = 'select.js-search-select';
    const selectorMaxSize = 5;
    const selectorMinSize = 2;
    const queryMinLength = 2;

    $(selector).find('option').remove();
    $(selector).addClass('hide');
    $(selector).attr('size', selectorMinSize);
    if(typeof query !== "string" || query.length >= queryMinLength && $(selector).length){
      const request = BX.ajax.runComponentAction('alx:order.bill', 'getData', {
        mode:'ajax',
        data: {
          'query': query
        }
      });

      request.then((response: any) => {
        if(response && response.status === 'success'){
          $(selector).find('option').remove();
          $(selector).addClass('hide');
          $(selector).attr('size', selectorMinSize);

          // tslint:disable-next-line:ter-prefer-arrow-callback
          $.each(response.data, function(i, v){
            $(selector).append($('<option>', {
              'value': JSON.stringify(v.data),
              // tslint:disable-next-line:prefer-template
              'text': v.value + ' (' + v.data.inn +', ' + v.data.address.value + ')'
            }));
            let maxSize = response.data.length;
            if(maxSize > selectorMaxSize){
              maxSize = selectorMaxSize;
            }
            if(maxSize < selectorMinSize){
              maxSize = selectorMinSize;
            }
            $(selector).attr('size', maxSize);
            $(selector).removeClass('hide');
          });

          if ($(selector).hasClass('js-custom-select') && typeof (<any>window)['initCustomSelect'] === 'function') {
            $(selector).attr('size', null);
            (<any>window)['initCustomSelect']('100%');
          }
        }else{
          console.log(response)
          alert('Request error!');
        }
      }, (response: any) => {
        console.log(response)
        alert('Request error!');
      });
    }
  });

  $(document).on('click', '.js-btn-direct-prev', function(e){
    e.preventDefault();
    location.href = (BX.message('LANGUAGE_ID') === 'en' ? '/eng/' : '/');
  });
});
